"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAddress = formatAddress;
function formatAddress(address) {
    return address.toLocaleLowerCase().substring(2).padStart(40, '0');
}
